import { styled } from "@mui/material/styles";

export const StyledTableBody = styled("tbody")({
  tr: {
    borderBottom: "1px solid rgba(0,0,0,0.2)",
  },
  "tr:last-child": {
    borderBottom: "none",
  },
});
